export default __webpack_public_path__ + "static/media/army_123.387e2579.jpg";